var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full justify-center items-center"},[_c('youtube',{staticClass:"mt-4",attrs:{"video-id":_vm.videoId,"player-width":_vm.playerWidth,"player-height":_vm.playerHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }